'use strict';

var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var makeStyles = require('../../../DesignSystem/Styles/makeStyles.js');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var InfoChip = require('../../../DesignSystem/DataDisplay/InfoChip/InfoChip.js');
var Card = require('../../../DesignSystem/Surfaces/Cards/Card.js');
var UnitCardInfo = require('./UnitCardInfo.js');
var ToasterAlert = require('../../../DesignSystem/Feedback/ToasterAlert/ToasterAlert.js');
var CardMedia = require('../../../node_modules/@material-ui/core/esm/CardMedia/CardMedia.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useClasses = makeStyles["default"](function (theme) {
  return {
    root: function root(_ref) {
      var fullWidth = _ref.fullWidth,
          isHoverDisabled = _ref.isHoverDisabled;
      return {
        overflow: 'hidden',
        cursor: 'pointer',
        maxWidth: fullWidth ? '100%' : theme.spacing(53),
        width: fullWidth ? '100%' : 'initial',
        '&:hover': {
          backgroundColor: isHoverDisabled ? theme.palette.common.white : theme.palette.action.hover
        }
      };
    },
    infoChip: _objectSpread({}, theme.typography.eyebrow, {
      lineHeight: 1,
      padding: theme.spacing(0.375, 1),
      borderRadius: 24,
      borderWidth: 1,
      borderColor: theme.palette.common.black,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.common.black,
      display: 'inline-block',
      borderStyle: 'solid'
    }),
    verticalLayout: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      justifyContent: 'stretch',
      alignItems: 'stretch'
    },
    chipContainer: {
      position: 'absolute',
      top: theme.spacing(0.75),
      left: theme.spacing(0.75)
    }
  };
});

var CoachingUnitCard = function CoachingUnitCard(_ref2) {
  var title = _ref2.title,
      description = _ref2.description,
      category = _ref2.category,
      imageUrl = _ref2.imageUrl,
      _ref2$fullWidth = _ref2.fullWidth,
      fullWidth = _ref2$fullWidth === void 0 ? false : _ref2$fullWidth,
      showAlert = _ref2.showAlert,
      onCloseAlert = _ref2.onCloseAlert,
      onClick = _ref2.onClick,
      dataTestId = _ref2['data-testid'],
      statusProps = objectWithoutProperties(_ref2, ["title", "description", "category", "imageUrl", "fullWidth", "showAlert", "onCloseAlert", "onClick", "data-testid"]);

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      isHoverDisabled = _useState2[0],
      setIsHoverDisabled = _useState2[1];

  var classes = useClasses({
    fullWidth: fullWidth,
    isHoverDisabled: isHoverDisabled
  });
  return React__default["default"].createElement(Card, {
    "data-testid": dataTestId,
    onClick: onClick,
    classes: {
      root: classes.root
    }
  }, React__default["default"].createElement(ToasterAlert, {
    open: showAlert,
    severity: statusProps.isSaved ? 'success' : 'info',
    onClose: onCloseAlert
  }, statusProps.isSaved ? 'Saved in Conquer' : 'Removed from saved list'), React__default["default"].createElement("div", {
    className: classes.verticalLayout
  }, React__default["default"].createElement(CardMedia["default"], {
    component: "img",
    alt: description,
    title: title,
    image: imageUrl,
    height: "140"
  }), React__default["default"].createElement("div", {
    className: classes.chipContainer
  }, React__default["default"].createElement(Typography, {
    version: "v2",
    variant: "button"
  }, React__default["default"].createElement(InfoChip, {
    className: classes.infoChip,
    label: category
  }))), React__default["default"].createElement(UnitCardInfo, _objectSpread({}, statusProps, {
    title: title,
    setIsHoverDisabled: setIsHoverDisabled
  }))));
};

module.exports = CoachingUnitCard;
